import React, { useState, useEffect } from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
import { Dialog, DialogTitle, DialogContent, Button } from "@mui/material";
import GoogleMapKey from "../../../../../pages/Utils/googleMapKey";
// const API_KEY = "AIzaSyAbjDBiTEtZk7aA2M-L-ErDEDfUUktIVEM";
// const API_KEY = "AIzaSyAbjDBiTEtZk7aA2M-L-ErDEDfUUktIVEM";

const containerStyle = {
  width: "100%",
  height: "400px",
};

function NewLocationPicker({
  open,
  onClose,
  onSelectLocation,
  selectedLocation,
  setSelectedLocation,
}) {
  // Function to get the user's current location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setSelectedLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          console.error("Error fetching location:", error);
          // Fallback location if user denies access
          setSelectedLocation({
            lat: 23.8859, // Default Latitude
            lng: 45.0792, // Default Longitude
          });
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
      setSelectedLocation({
        lat: 23.8859,
        lng: 45.0792,
      });
    }
  }, []);

  // Function to update marker position on map click
  const handleMapClick = (event) => {
    setSelectedLocation({
      lat: event.latLng.lat(),
      lng: event.latLng.lng(),
    });
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Select a Location</DialogTitle>
      <DialogContent>
        <LoadScript googleMapsApiKey={GoogleMapKey}>
          {selectedLocation && (
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={selectedLocation}
              zoom={12}
              onClick={handleMapClick}
            >
              <Marker position={selectedLocation} />
            </GoogleMap>
          )}
        </LoadScript>
        {/* <Button
          fullWidth
          variant="contained"
          color="dark"
          onClick={() => onSelectLocation(selectedLocation)}
          sx={{ mt: 2 }}
          disabled={!selectedLocation}
        >
          Select Location
        </Button> */}
      </DialogContent>
    </Dialog>
  );
}

export default NewLocationPicker;
